export const MENU_CATEGORY = 'MENU_CATEGORY';
export const BUY_TOKEN_INFO = 'BUY_TOKEN_INFO';